<header class="background-header classic-background"></header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}"
	  *ngIf="showAllUsers == true">
	<section class="container admin-dashboard-parent partners-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Partners'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
                <h1>Partners</h1>
			</div>
		</section>
		<!-- Search -->
		<section class="all-users-line-presentation">
			<div class="search-section">
				<div class="accounts-number">
					<span>
						<!-- {{users.length}} --> X partners
					</span>
				</div>
				<div class="buttons-managment">
					<input type="text" class="dashboard-input" placeholder="Partner Name">
					<input type="button" class="btn btn-primary search-btn" value="Search">
					<input type="button" class="btn btn-primary export-btn" value="Export" (click)="exportAsXLSX()">
				</div>
			</div>
		</section>
		<!-- Table data -->
		<section class="all-users-data">
			<div class="table-responsive admin-dashboard-table">
				<table class="table table-borderless table-hover">
					<thead>
					<tr>
						<th scope="col">Partner Name</th>
						<th scope="col">Sign up code</th>
						<th scope="col">Accounts created</th>
						<th scope="col">Paid accounts</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let dataUser of partnersUsers" (click)="onSelect(dataUser)">
						<td>{{dataUser.partName}}</td>
						<td>{{dataUser.signUp}}</td>
						<td>{{dataUser.accountsCreated}}</td>
						<td>{{dataUser.paidAccounts}}</td>
					</tr>
					</tbody>
				</table>
			</div>
		</section>
	</section>
</section>
<app-partners-details *ngIf="userDetail == true" [dataUser]="selectedUser"
					  (onClick)="backFromDetailUser()"></app-partners-details>
